import { useState, useEffect } from 'react'
import {Link} from 'react-router-dom'
import SwiperCore, {Navigation} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import {Button} from 'reactstrap'
import axios from 'axios'
import GetCurrentLang from '../helper/GetCurrentLang'
import { replaceSpecialChar } from '../helper/replaceSpecialChar'

SwiperCore.use([Navigation]);

interface Categories {
  id: number,
  thumbnail: any[string]
}

const SlidingHighlights = (props : any) => {
  const [categories, setCategories] = useState<Categories[]>([])

  useEffect(() => {
    axios.get(`${process.env.PUBLIC_URL}/data/categories-${GetCurrentLang()}.json`)
    .then((res) => {
      setCategories(res.data[0])
    })
  }, [])

  function SetCategory(category : any){
    // props.resetFilter()
    props.setCategoryFilter(category)
  }
  
  return (
    <div className="SlidingHighlights">
      {categories.length > 0 && (
        <Swiper
          spaceBetween={10}
          slidesPerView={'auto'}
          navigation={{
            nextEl: '.next-el',
            prevEl: '.prev-el'
          }}
          breakpoints={{
            480: {
              slidesPerView: 2,
              spaceBetween: 10
            },
            768: {
              slidesPerView: 'auto',
              spaceBetween: 20
            }
          }}
        >
          {categories.map((slider : any, i : number) => (
            <SwiperSlide key={i}>
              <div className="shadow CardOverlay">
                <Link 
                  to={{
                    pathname: '/year-end-category',
                    search: `?category=${slider.id}`
                  }} 
                  onClick={() =>  {
                    SetCategory([String(slider.id)])
                    window.dataLayer.push({
                      'event': 'promotioncategory',
                      'promotion_category': replaceSpecialChar(slider.name)
                    });
                  }}
                  className="stretched-link"
                >
                  <img src={slider.thumbnail} className="icon" alt={slider.name} />
                </Link>
                <div className="inner">
                  <Link 
                    to={{
                      pathname: '/year-end-category',
                      search: `?category=${slider.id}`
                    }} 
                    onClick={() =>  {
                      SetCategory([String(slider.id)])
                      window.dataLayer.push({
                        'event': 'promotioncategory',
                        'promotion_category': slider.name
                      });
                    }}
                    className="d-block stretched-link cat-name" dangerouslySetInnerHTML={{ __html: slider.name }} />
                </div>
              </div>
            </SwiperSlide>
          ))}
          <div className="d-flex justify-content-end navigation-wrapper">
            <Button color="link" className="prev-el nav-slider swiper-button-disabled">‹</Button>
            <Button color="link" className="next-el nav-slider">›</Button>
          </div>
        </Swiper>
      )}
    </div>
  )
}

export default SlidingHighlights